var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let _global = {};
if (typeof window === "object") {
  _global = window;
}
const finger_device_url = "/common-static/cht-static/security-svc/js/finger_device.js";
const createByDeviceTx = () => {
  const ByFingerPrintReportFun = (options) => __async(void 0, null, function* () {
    console.log("");
  });
  const getEventUUIDFun = () => __async(void 0, null, function* () {
    console.log("");
  });
  const getTxIdFun = () => __async(void 0, null, function* () {
    return "";
  });
  const getDeviceNameFun = () => __async(void 0, null, function* () {
    return "";
  });
  const getGdfp2Fn = () => __async(void 0, null, function* () {
    return "";
  });
  _global.byDeviceTx = {
    ByFingerPrintReport: ByFingerPrintReportFun,
    getEventUUID: getEventUUIDFun,
    getTxId: getTxIdFun,
    getDeviceNameAsync: getDeviceNameFun,
    getGdfp: getTxIdFun,
    getGdfp2: getGdfp2Fn
  };
};
const initFn = () => __async(void 0, null, function* () {
  var _a, _b, _c;
  if (_global.navigator && ((_a = _global.navigator) == null ? void 0 : _a.brave)) {
    const isBool = yield (_c = (_b = _global.navigator) == null ? void 0 : _b.brave) == null ? void 0 : _c.isBrave();
    if (isBool) {
      createByDeviceTx();
      return _global.byDeviceTx;
    }
  }
  if (_global.byDeviceTx)
    return _global.byDeviceTx;
  _global.byDeviceLoading = true;
  const el = document.createElement("script");
  el.src = finger_device_url;
  document.head.append(el);
  return new Promise((rs) => {
    el.addEventListener("error", () => {
      createByDeviceTx();
      rs(_global.byDeviceTx);
    });
    el.addEventListener("load", () => {
      rs(_global.byDeviceTx);
    });
  });
});
const fingerprintInit = initFn;
export { fingerprintInit };
